import React, { memo, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { noop } from 'lodash-es';
import { MarkdownLink } from 'site-modules/personalized-search/components/markdown/markdown-link/markdown-link';
import { useAccumulatedComponentData } from 'site-modules/personalized-search/hooks/use-accumulated-component-data';
import { logger } from 'client/utils/logger/logger';

import './markdown.scss';

const useLogNestedJsonStructure = (content, searchId) => {
  const reportNestedJson = useRef(() => {
    logger.warn('Markdown content contains nested JSON structure', null, { key: searchId });

    reportNestedJson.current = noop;
  });

  useEffect(() => {
    if (content?.includes('{"component"')) {
      reportNestedJson.current(content);
    }
  }, [content]);
};

export const Markdown = memo(({ items, searchId = undefined }) => {
  const { content } = useAccumulatedComponentData({
    items,
    initialData: { content: '' },
  });

  useLogNestedJsonStructure(content, searchId);

  return (
    <>
      <div
        className="markdown base-inner-width bg-transparent px-1 px-md-0_5 px-lg-0 mx-md-auto"
        data-tracking-parent="edm-entry-agent-answer-component"
      >
        {content && (
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              a: MarkdownLink,
            }}
          >
            {content}
          </ReactMarkdown>
        )}
      </div>
    </>
  );
});

Markdown.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      data: PropTypes.shape({
        content: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.string]),
      }),
    })
  ).isRequired,
  searchId: PropTypes.string,
};

Markdown.displayName = 'Markdown';
